import { QueryLazyOptions } from "@apollo/client";
import Autocomplete from "@saleor/components/Autocomplete";
import {
  Exact,
  ExportShipToFilterInput,
  ExportSoldToFilterInput,
  RequireAttentionSaleEmployeeFilterInput
} from "@saleor/graphql";
import React, { useEffect, useState } from "react";

interface IProps {
  handleSelectedSearch?: (value: string) => void;
  inputValue?: string;
  setInputValue?: React.Dispatch<React.SetStateAction<string>>;
  placeholder?: string;
  first?: number;
  isClean: boolean;
  contained?: boolean;
  name: string;
  getDataSuggestions: (
    options?: QueryLazyOptions<
      Exact<{
        filter?:
          | ExportShipToFilterInput
          | ExportSoldToFilterInput
          | RequireAttentionSaleEmployeeFilterInput;
        first?: number;
      }>
    >
  ) => void;
  fetchDataSuggestions?: any;
  loadingDataSuggestion: boolean;
  dataOptions: any[];
  error?: boolean;
  searchField?: string;
  isCustomer?: boolean;
  id?: string;
}

interface FilterObjectProps {
  search?: string;
  shipTo?: string;
  accountGroupCode?: string[];
}

const InputSuggestion: React.FC<IProps> = (props: IProps) => {
  const {
    handleSelectedSearch,
    placeholder,
    first,
    isClean,
    contained,
    getDataSuggestions,
    loadingDataSuggestion,
    name,
    dataOptions,
    error,
    searchField,
    isCustomer,
    id
  } = props;

  const [value, setValue] = useState<string>("");

  const handleChange = event => {
    setValue(event);
  };

  useEffect(() => {
    if (value.length >= 2) {
      const filterObj: FilterObjectProps =
        name === "soldTo" || name === "createBy"
          ? { search: value }
          : { shipTo: value };

      if (isCustomer) {
        filterObj.accountGroupCode = ["Z001", "DREP"];
      }

      const finalFilterObj = searchField
        ? {
            [searchField]: value
          }
        : filterObj;

      getDataSuggestions({
        variables: {
          first: first || 100,
          filter: finalFilterObj
        }
      });
    }
  }, [value]);

  const onSearch = value => {
    if (dataOptions.find(item => item.title === value)) {
      handleSelectedSearch(value);
    }
  };

  return (
    <>
      <Autocomplete
        contained={contained}
        optionsProp={dataOptions}
        placeholderProps={placeholder}
        onChangeProps={handleChange}
        loading={loadingDataSuggestion}
        onSearch={onSearch}
        isReset={isClean}
        error={error}
        id={id}
        name={name}
      />
    </>
  );
};

export default InputSuggestion;
